export var TechnicianLevel;
(function (TechnicianLevel) {
    TechnicianLevel[TechnicianLevel["Junior"] = 0] = "Junior";
    TechnicianLevel[TechnicianLevel["Senior"] = 1] = "Senior";
    TechnicianLevel[TechnicianLevel["Service"] = 2] = "Service";
    TechnicianLevel[TechnicianLevel["AllRound"] = 3] = "AllRound";
})(TechnicianLevel || (TechnicianLevel = {}));
